module.exports = __webpack_public_path__ + "img/Malla-Mosquitera.32716db5.jpg";